import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, Zap, Lock } from 'lucide-react';
import { Button } from './ui/Button';
export function OfferBlock() {
  return <section id="oferta" className="w-full bg-midnight py-24 px-6" data-id="element-110">
      <div className="max-w-4xl mx-auto" data-id="element-111">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-112">
          <h2 className="font-display text-3xl md:text-5xl text-bone uppercase leading-tight mb-6" data-id="element-113">
            Recupera tus noches y tu <br className="hidden md:block" data-id="element-114" />
            virilidad mental hoy mismo.
          </h2>
          <p className="text-steel text-lg max-w-2xl mx-auto" data-id="element-115">
            Obtén el sistema completo "S.O.S. Insomnio Masculino" por una
            inversión única.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="bg-midnight-deep border-2 border-cyan-signal p-8 md:p-12 relative shadow-[0_0_40px_rgba(61,169,252,0.1)]" data-id="element-116">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-cyan-signal text-midnight-deep px-6 py-2 font-bold uppercase tracking-widest text-sm whitespace-nowrap" data-id="element-117">
            50% OFF · Precio Especial de Lanzamiento
          </div>

          <div className="flex flex-col md:flex-row gap-12 items-center mb-12 mt-4" data-id="element-118">
            <div className="w-full md:w-1/3" data-id="element-119">
              <img src="https://cdn.magicpatterns.com/uploads/csFt1e6LnfV1hpmHvacF7z/IM1.png" alt="S.O.S. Insomnio Masculino" className="w-full h-auto object-contain drop-shadow-xl" data-id="element-120" />
            </div>

            <div className="w-full md:w-2/3 space-y-6" data-id="element-121">
              <div className="text-center md:text-left border-b border-cyan-signal/20 pb-6" data-id="element-122">
                <p className="text-steel uppercase tracking-widest text-sm font-bold mb-2" data-id="element-123">
                  Inversión Única · Acceso de por vida
                </p>
                <div className="flex items-baseline gap-4 justify-center md:justify-start flex-wrap" data-id="element-124">
                  <span className="font-display text-2xl md:text-3xl text-steel/60 line-through decoration-alert decoration-2" data-id="element-125">
                    $54
                  </span>
                  <div className="font-display text-6xl md:text-7xl text-amber-price" data-id="element-126">
                    $27 <span className="text-3xl" data-id="element-127">USD</span>
                  </div>
                  <span className="font-display text-xl md:text-2xl bg-alert text-bone px-3 py-1 -rotate-6 shadow-lg" data-id="element-128">
                    -50%
                  </span>
                </div>
                <div className="mt-3 inline-flex items-center gap-2 bg-alert/10 border border-alert/30 px-3 py-1" data-id="element-129">
                  <span className="text-alert font-bold uppercase tracking-widest text-xs" data-id="element-130">
                    Ahorras $27 USD · 50% de descuento
                  </span>
                </div>
              </div>

              <ul className="space-y-3" data-id="element-131">
                {['eBook Maestro S.O.S. Insomnio Masculino', 'El Método de Vaciado "Caja Negra"', 'Protocolo de Higiene Térmica 90-10', 'La Regla de Triaje de las 3 AM', 'Checklist de Habitación Blindada'].map((item, i) => <li key={i} className="flex items-start gap-3" data-id="element-132">
                    <Check className="w-5 h-5 text-cyan-signal flex-shrink-0 mt-0.5" data-id="element-133" />
                    <span className="text-bone font-medium" data-id="element-134">{item}</span>
                  </li>)}
              </ul>
            </div>
          </div>

          <div className="flex flex-col items-center" data-id="element-135">
            <Button showLock subtext="Pago seguro · Acceso inmediato" className="w-full max-w-xl text-xl py-5" data-id="element-136">
              Mándame el Protocolo Ahora
            </Button>

            <div className="flex flex-wrap justify-center gap-6 mt-8 text-steel text-sm font-medium" data-id="element-137">
              <div className="flex items-center gap-2" data-id="element-138">
                <Lock className="w-4 h-4 text-cyan-signal" data-id="element-139" />
                Pago Seguro
              </div>
              <div className="flex items-center gap-2" data-id="element-140">
                <Zap className="w-4 h-4 text-cyan-signal" data-id="element-141" />
                Acceso Inmediato
              </div>
              <div className="flex items-center gap-2" data-id="element-142">
                <ShieldCheck className="w-4 h-4 text-cyan-signal" data-id="element-143" />
                Garantía de Satisfacción
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}